/** @jsx jsx */
import React from "react"
import SEO from "../components/seo"
import "bulma"
import { graphql, useStaticQuery } from "gatsby"
import GatsbyImage from "gatsby-image"
import { Container, jsx } from "theme-ui"
import { Complaint } from "../components/Complaint"

const IndexPage = () => {
  const images = useStaticQuery(graphql`
      query {
          reddit1: file(relativePath: { eq: "reddit1.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          reddit2: file(relativePath: { eq: "reddit2.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          reddit3: file(relativePath: { eq: "reddit3.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          reddit4: file(relativePath: { eq: "reddit4.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          reddit5: file(relativePath: { eq: "reddit5.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          reddit6: file(relativePath: { eq: "reddit6.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          reddit7: file(relativePath: { eq: "reddit7.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          reddit8: file(relativePath: { eq: "reddit8.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          esk8news: file(relativePath: { eq: "esk8news.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          bendingMounts: file(relativePath: { eq: "bending-mounts.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          bbb: file(relativePath: { eq: "bbb.png" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
          batteryIssue: file(relativePath: { eq: "battery-issue.jpg" }) {
              childImageSharp {
                  fluid(maxWidth: 1000) {
                      ...GatsbyImageSharpFluid
                  }
              }
          }
      }
  `)

  return <>
    <SEO title="Complaints"/>
    <section className="hero" sx={{background: 'linear-gradient(120deg, #b70357 0%,#11005e 100%);'}}>
      <div sx={{padding: '3rem 0'}}>
        <Container px={4}>
          <h1 className="title" sx={{color: '#fff'}}>
            DIYElectricSkateboard.com / Torqueboards<br/>is not a reliable vendor!
          </h1>
          <h2 className="subtitle" sx={{color: '#fff'}}>
            Over the years Dexter (the owner) has provided terrible post-sales customer service and accumulated many
            complaints. Do not buy from this vendor!
          </h2>
        </Container>
      </div>
    </section>
    <Container px={4}>
      <br/>
      <h1 className="title">Complaints</h1>

      <Complaint href="https://www.reddit.com/r/ElectricSkateboarding/comments/llmlrp/torqueboards_and_diyelectricsk8_pos_dont_waste/">
        Customer's battery explodes just by plugging it in normally
        <br/><br/>
        <GatsbyImage fluid={images.batteryIssue.childImageSharp.fluid}/>
      </Complaint>

      <Complaint href="https://youtu.be/t9v3Kabeedg">
        Customer paid more than $1500 for a board that broke immediately and DIYElectricSkateboards customer service did
        not help for over three years
        <br/><br/>
        <div sx={{
          position: "relative",
          paddingBottom: "56.25%",
          height: 0,
          overflow: "hidden",
          maxWidth: "100%"
        }}>
          <iframe
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%"
            }}
            title="DIYElectricSkateboard / Torqueboards Postmortem"
            src='https://www.youtube.com/embed/t9v3Kabeedg'
            frameBorder='0'
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen/>
        </div>
      </Complaint>

      <Complaint href="https://www.reddit.com/r/ElectricSkateboarding/comments/7i13rs/diyelectricskateboard_service/dqvzrfl?utm_source=share&utm_medium=web2x">
        Customer has repeated hardware failures and customer service is absent
        <br/><br/>
        <GatsbyImage fluid={images.reddit1.childImageSharp.fluid}/>
      </Complaint>

      <Complaint
        href="https://www.reddit.com/r/ElectricSkateboarding/comments/6upvif/torqueboards_making_it_very_difficult_to_receive/">
        Customer has to go through PayPal to get refund on a product he never received, complains about horrible customer service
        <br/><br/>
        <GatsbyImage fluid={images.reddit7.childImageSharp.fluid}/>
      </Complaint>

      <Complaint href="https://forum.esk8.news/t/torqueboards-customer-service/11318">
        Forum thread about poor customer service and how it has recently been getting even worse
        <br/><br/>
        <GatsbyImage fluid={images.esk8news.childImageSharp.fluid}/>
      </Complaint>

      <Complaint href="https://www.reddit.com/r/ElectricSkateboarding/comments/h7o7p0/battery_issues/">
        DIYElectricSkateboard sells poor quality components
        <br/><br/>
        <GatsbyImage fluid={images.reddit2.childImageSharp.fluid}/>
      </Complaint>

      <Complaint
        href="https://www.reddit.com/r/ElectricSkateboarding/comments/hf6adq/anyone_had_issues_with_diyelectricskateboardcom/">
        Poor customer service won't respond
        <br/><br/>
        <GatsbyImage fluid={images.reddit3.childImageSharp.fluid}/>
      </Complaint>

      <Complaint href="https://forum.esk8.news/t/possible-issue-with-torqueboards-motor-mounts/30423">
        Motor mounts bend after 50 miles
        <br/><br/>
        <GatsbyImage fluid={images.bendingMounts.childImageSharp.fluid}/>
      </Complaint>

      <Complaint href="https://www.reddit.com/r/ElectricSkateboarding/comments/c3sx93/torqueboard_stuff/">
        Customer complains of poor customer service and shipping issues
        <GatsbyImage fluid={images.reddit4.childImageSharp.fluid}/>
      </Complaint>

      <Complaint href="https://www.reddit.com/r/ElectricSkateboarding/comments/i3ait5/diyelectricskateboardtorqueboard_postmortem/g0cn573">
        Customer doesn't receive half of their order and gets ghosted
        <br/><br/>
        <GatsbyImage fluid={images.reddit8.childImageSharp.fluid}/>
      </Complaint>

      <Complaint href="https://www.reddit.com/r/ElectricSkateboarding/comments/7i13rs/diyelectricskateboard_service/dqvapbf">
        TorqueBoards prices are too expensive for what you get
        <GatsbyImage fluid={images.reddit5.childImageSharp.fluid}/>
      </Complaint>

      <Complaint
        href="https://www.reddit.com/r/ElectricSkateboarding/comments/hn40x4/torqueboards_customer_service_and_shipping_delays/">
        Reddit user complains about poor customer service and shipping delays. Comments are full of similar bad
        experiences.
      </Complaint>

      <Complaint
        href="https://www.reddit.com/r/ElectricSkateboarding/comments/c3sx93/torqueboard_stuff/ertkvqo">
        Customer complains about order issues
        <br/><br/>
        <GatsbyImage fluid={images.reddit6.childImageSharp.fluid}/>
      </Complaint>

      <Complaint
        href="https://www.bbb.org/us/tx/prosper/profile/online-retailer/diyelectricskateboardcom-0875-90885828">
        DIYElectricSkateboard.com has an F-grade on BBB
        <br/><br/>
        <GatsbyImage fluid={images.bbb.childImageSharp.fluid}/>
      </Complaint>
    </Container>
  </>
}


export default IndexPage
